
import { AnyAction } from "redux"
import { LOCATIONS_DASHBOARD_DATA_FAIL, LOCATIONS_DASHBOARD_DATA_REQ, LOCATIONS_DASHBOARD_DATA_SUCC, PRODUCTS_DASHBOARD_DATA_FAIL, PRODUCTS_DASHBOARD_DATA_REQ, PRODUCTS_DASHBOARD_DATA_SUCC } from "redux/actions/dashboard/type"
 


interface State {
    loading?: boolean
    data?: any,
    error?: string,


}

const defaultState: State = {
    loading: false,
    data: [],


}


// export const LOCATIONS_DASHBOARD_DATA_FAIL="LOCATIONS_DASHBOARD_DATA_FAIL"
// export const LOCATIONS_DASHBOARD_DATA_REQ="LOCATIONS_DASHBOARD_DATA_REQ"
// export const LOCATIONS_DASHBOARD_DATA_SUCC="LOCATIONS_DASHBOARD_DATA_SUCC"

export const getlocationsDashboardReducer = (state: State = defaultState, action: AnyAction) => {
    switch (action.type) {
        case LOCATIONS_DASHBOARD_DATA_REQ:

            return {
                loading: true,
                data: state.data
            }
        case LOCATIONS_DASHBOARD_DATA_SUCC:

            return {
                loading: false,
                data: action.payload,

            }
        case LOCATIONS_DASHBOARD_DATA_FAIL:
            return {
                loading: false,
                error: action.payload
            }


        default:
            return state;
    }
}